
import { useState } from "react"
import { motion } from "framer-motion";
import Carging from "../Carging";

import { addDoc, collection } from 'firebase/firestore';
import { db } from '../../firebaseConfig';


const ContactForm = () => {
    const [contac, setContac] = useState({ name: null, email: null, message: null });
    const [input, setInput] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    const style = {
        backgroundColor: "#2f2f2f",
        border: 'none',
        borderBottom: '1px solid #CACACA',
        color: '#CACACA',

    }

    const handelNext = (e) => {
        e.preventDefault();
        setInput('');
        setContac({ ...contac, [e.target.name]: input });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSaving(true);
        contac.message = input;
        const messageRef = collection(db, 'messages');
        addDoc(messageRef, contac)
            .then(() => {
                setIsSaving(false);
                setContac({ name: null, email: null, message: null });
            })
            .catch(() => {
                setIsSaving(false);
            })
        setInput('');
        setContac({ name: null, email: null, message: null });
        setIsSaving(false);
    }


    return (
        <form
            autoComplete="off"
            className="w-100"
            onSubmit={(e) => handleSubmit(e)}
        >
            <div className="contact mt-3">
                &nbsp;
                {contac.name && <motion.span
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.5 }}
                    className="badge bg-secondary m-2 ">
                    {contac.name}
                </motion.span>}
                {contac.email && <motion.span
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.5 }}
                    className="badge bg-secondary m-2 ">{contac.email}
                </motion.span>}
            </div>
            <div className="form-floating mb-3">
                <input
                    type="text"
                    className="form-control"
                    id="input"
                    placeholder="name@example.com"
                    style={style}
                    onChange={(e) => setInput(e.target.value)}
                    value={input}
                />

                <label htmlFor="input">
                    <i className="bi bi-person" /> &nbsp;
                    {!contac.name ?
                        <span >fill with your name</span> :
                        !contac.email ? <span >enter your email address</span> :
                            !contac.message ? <span >write your message</span> : null
                    }
                </label>
            </div>

            <div className="form-floating mb-3">
                <button
                    type="button"
                    name={!contac.name ?
                        'name' :
                        !contac.email ? 'email' :
                            !contac.message ? 'message' : null
                    }
                    onClick={(e) => handelNext(e)}
                    className={`btn btn-${!input ? 'secondary disabled' : 'primary'} ${contac.email && contac.name ? ' disabled btn-secondary' : null}  me-2`}>
                    Next
                </button>
                <button
                    type="submit"
                    className={`btn btn-${contac.email && contac.name && input ? 'primary' : 'secondary disabled'}`}>
                    <span>
                        {isSaving ? <Carging /> : 'Send'}
                    </span>
                </button>

            </div>
        </form>

    )

}
export default ContactForm

